var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-dropdown-search-selection.ts
import { A } from "@adornis/base/env-info";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { BehaviorController } from "@adornis/chemistry/controllers/behavior-controller";
import { ObservableController } from "@adornis/chemistry/controllers/observable-controller";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-flex";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design";
import { elevation } from "@adornis/chemistry/elements/token-helpers";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import "@adornis/chemistry/renderable";
import { FormField } from "@adornis/forms/form-field";
import "@adornis/forms/x-input";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { guard } from "lit/directives/guard.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { live } from "lit/directives/live.js";
import { ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { combineLatest, takeUntil } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import "./a-drop-wrapper";
var ElementsDropdownSearchSelection = class extends FormField {
  constructor() {
    super(...arguments);
    this.selectables = new BehaviorController(this, []);
    this.searchString = new BehaviorController(this, void 0);
    this.guardKey = "";
    this.searchResultSelectables = new ObservableController(
      this,
      combineLatest([this.searchString, this.selectables]).pipe(
        // debounceTime(200),
        switchMap(async ([str, selectables]) => (!str ? selectables : this.search?.(str)) ?? []),
        tap((arr) => {
          if (!Array.isArray(arr))
            throw new Error("search callback didnt give me an array");
        })
      )
    );
    this.selectedIndex = -1;
    this.placeholder = "";
    this["placeholder-mode"] = "floating";
    this.label = "";
    this["hide-add-button"] = false;
    this.renderItem = (x) => html`
    <x-flex
      ${css({
      padding: `${this.spacing.sm} ${this.spacing.md}`,
      borderBottom: `1px solid ${this.colors.neutral_100}`
    })}
    >
      <x-text> ${this.renderString(x)} </x-text>
    </x-flex>
  `;
    this.renderString = (x) => typeof x === "string" || typeof x === "number" ? x.toString() : JSON.stringify(x);
    this.resolveID = (x) => x?._id || A.getGloballyUniqueID();
    this.search = null;
  }
  connectedCallback() {
    super.connectedCallback();
    this.value.asObservable().pipe(takeUntil(this.disconnected)).subscribe((v) => this.searchString.next(this.renderString(v)));
  }
  render() {
    return xComponents(html`
      <a-dropdown id="dropdown" ${ref((dropdown) => this._adropdown = dropdown)}>
        ${this.trigger()}
        <x-dropdown-search-selection-content slot="dropdown-content">
          ${guard(
      [
        (this.searchResultSelectables.value || []).map((srs) => this.guardKey ? srs[this.guardKey] : srs).join(","),
        this.selectedIndex
      ],
      () => html`
              ${repeat(
        this.searchResultSelectables.value || [],
        (s) => this.resolveID(s),
        (selectable, idx) => {
          return xComponents(html`
                    <x-flex
                      ?selected=${this.selectedIndex === idx}
                      ${css({ cursor: "pointer" })}
                      @mousedown=${() => {
            this.commitValue(selectable);
          }}
                    >
                      ${this.renderItem(selectable)}
                    </x-flex>
                  `);
        }
      )}
            `
    )}
        </x-dropdown-search-selection-content>
      </a-dropdown>
    `);
  }
  trigger() {
    return xComponents(html`
      <x-flex>
        <x-input
          error=${ifDefined(this.error)}
          placeholder="${this.label || this.placeholder || ""}"
          placeholder-mode=${this["placeholder-mode"]}
          icon="${!this["hide-add-button"] && this.searchString.value ? "add" : ""}"
          ?disabled=${this.disabled}
          .value="${live(
      this.searchString.value === void 0 ? this.renderString(this.value.value) : this.searchString.value
    )}"
          @icon-click="${() => this.addEvent()}"
          @submit="${() => this.commitValue()}"
          @value-changed="${(e) => {
      if (this.searchString.value !== e.detail.value) {
        this.searchString.next(e.detail.value);
      }
    }}"
          @focus=${(e) => this.openDropdown()}
          @blur=${() => {
      if (this.searchString.value !== this.renderString(this.value.value)) {
        setTimeout(() => this.commitValue());
      }
    }}
        ></x-input>
      </x-flex>
    `);
  }
  openDropdown() {
    this._adropdown?.open();
  }
  closeDropdown() {
    this._adropdown?.close();
  }
  commitValue(selected) {
    const foundItem = selected || (this.searchResultSelectables.value || []).find((x) => {
      const string = this.renderString(x);
      const item = typeof string === "string" ? string.toLowerCase() : string;
      return item === this.searchString.value?.toLowerCase();
    });
    if (foundItem) {
      this.value.next(foundItem);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: foundItem } }));
    } else {
      if (this.searchString.value) {
        this.value.next(this.value.value);
        this.addEvent();
      } else {
        console.log("setting value to null");
        this.value.next(null);
        this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: null } }));
      }
    }
    this.closeDropdown();
  }
  addEvent() {
    this.dispatchEvent(new CustomEvent("add", { detail: { value: this.searchString.value } }));
  }
};
__decorateClass([
  state()
], ElementsDropdownSearchSelection.prototype, "selectables", 2);
__decorateClass([
  state()
], ElementsDropdownSearchSelection.prototype, "searchString", 2);
__decorateClass([
  state()
], ElementsDropdownSearchSelection.prototype, "guardKey", 2);
__decorateClass([
  state()
], ElementsDropdownSearchSelection.prototype, "searchResultSelectables", 2);
__decorateClass([
  property({ reflect: true, type: Number })
], ElementsDropdownSearchSelection.prototype, "selectedIndex", 2);
__decorateClass([
  property({ attribute: true, reflect: true })
], ElementsDropdownSearchSelection.prototype, "placeholder", 2);
__decorateClass([
  property({ attribute: true, reflect: true })
], ElementsDropdownSearchSelection.prototype, "placeholder-mode", 2);
__decorateClass([
  property()
], ElementsDropdownSearchSelection.prototype, "label", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDropdownSearchSelection.prototype, "hide-add-button", 2);
ElementsDropdownSearchSelection = __decorateClass([
  customElement("x-dropdown-search-selection")
], ElementsDropdownSearchSelection);
var ElementsDropdownSearchSelectionContent = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => ({
      ":host": {
        display: "flex",
        flexDirection: "column",
        background: this.colors.white,
        borderRadius: this.sizes.borderRadius,
        boxShadow: elevation[2],
        userSelect: "none",
        maxHeight: "300px",
        overflowY: "auto",
        [`::slotted(${DesignSystem.prefix}-flex:hover)`]: { background: this.colors.neutral_100 },
        [`::slotted(${DesignSystem.prefix}-flex[selected])`]: { background: this.colors.neutral_100 }
      }
    });
  }
  render() {
    return html` <slot></slot> `;
  }
};
ElementsDropdownSearchSelectionContent = __decorateClass([
  customElement("x-dropdown-search-selection-content")
], ElementsDropdownSearchSelectionContent);
export {
  ElementsDropdownSearchSelection,
  ElementsDropdownSearchSelectionContent
};
